/* @ngInject */
function SignupController ($rootScope, $scope, $timeout, $state, $stateParams, $translate, $location, ConnectorWebService, CONSTANTS, MessageService, InitializerService, AuthService, IntercomService, StrongPasswordService, ToastService, Utils) {
  var sHost = $location.host()
  $scope.subdomain = ''
  $scope.sCustomerLogoPath = ''
  $scope.backgroundImageUrl = ''
  $scope.backgroundUrl = ''
  $scope.wrongMessage = {}
  $scope.isCompanyFieldDisabled = false
  $scope.isEmailDisabled = false
  $scope.userSignUp = {
    email: '',
    password: '',
    repeatPassword: '',
    name: '',
    company: ''
  }
  $scope.tokenHasBeenUsed = false
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true,
    loadingDataUser: true
  }

  $scope.passwordRules = {
    eight: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  }

  $scope.passwordStrength = 'NONE' // NONE, ONE, TWO, THREE, FOUR, FIVE
  $scope.strongPasswordEnabled = false

  const api = {
    _verifyTokenInUrlParams,
    _setInviteTokenWhenSignUp,
    _hasTokenLoadDataUser,
    _showErrorNotHasToken,
    _loadDataUserPerParameters,
    _loadOldInvitation
  }

  this.getApi = () => api

  activate()

  function activate () {
    AuthService.setContainerPosition()
    AuthService.getCustomerImages(sHost)
      .then(url => {
        $scope.subdomain = localStorage.getItem('companySubdomain')
        $scope.sCustomerLogoPath = url.logo
        $scope.backgroundUrl = url.background
      })

    api._verifyTokenInUrlParams($stateParams)

    StrongPasswordService.checkIfNeedsStrongPassword($stateParams.inviteToken).then(info => {
      $scope.strongPasswordEnabled = info.hasStrongPasswordActive
    })
  }

  function redirectToAppStore () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // Dispositivo iOS
      window.location.href = 'https://apps.apple.com/app/id1467794141' // Link para a App Store
    } else if (/android/i.test(userAgent)) {
      // Dispositivo Android
      window.location.href = 'https://play.google.com/store/apps/details?id=io.deskfy.mobile' // Link para a Google Play Store
    } else {
      // Outros dispositivos
      // Deixa ele utilizar o app normalmente pelo browser
    }
  }

  function displayMobileAppMessage () {
    const message = $translate.instant('textAccessTheMessage')
    return message
  }

  function showAppMobileNativeModal () {
    setTimeout(function () {
      const message = displayMobileAppMessage()
      const confirmDownload = confirm(message)
      // Redirecionar para a loja de aplicativos apropriada
      if (confirmDownload) { redirectToAppStore() }
    }, 1000)
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }

  $scope.signUp = function () {
    $scope.wrongMessage = {}

    api._setInviteTokenWhenSignUp($stateParams.inviteToken)

    if ($scope.userSignUp.password.length < 6) {
      $scope.wrongMessage.password = $translate.instant('passwordLengthMsg')
    } else if ($scope.userSignUp.password !== $scope.userSignUp.repeatPassword) {
      $scope.wrongMessage.password = $translate.instant('passwordNotEqualMsg')
    } else {
      $scope.signupBtnLoading = true
      $scope.userSignUp.company = $scope.userSignUp.company.replace(' ', '').toUpperCase()

      ConnectorWebService.post(
        CONSTANTS.URL_AUTH_SIGNUP,
        $scope.userSignUp
      ).then(
        function (res) {
          var accountCreatedMsg = $translate.instant('accountCreatedMsg')
          if ($stateParams.company && $stateParams.name && $stateParams.email) {
            accountCreatedMsg = $translate.instant('inviteAcceptedMsg')
          }
          $scope.userSignUp = {
            email: '',
            password: '',
            name: '',
            company: $stateParams.company
          }

          if (!res.invite) {
            MessageService.success({
              title: $translate.instant('accountCreated'),
              text: accountCreatedMsg,
              confirmButton: $translate.instant('goToLogin'),
              press: function () {
                // para não executar a landing page ao navegar de tela
                if (!Utils.isInReactNativeWebView() && !$rootScope.isDesktop) {
                  localStorage.setItem('landingPageFlowExecuted', 'true')
                  $rootScope.landingPageFlowExecuted = true
                  showAppMobileNativeModal()
                }
                $state.go('login')
              }
            })
            $scope.signupBtnLoading = false
          } else {
            InitializerService.initApplication().then(function () {
              MessageService.success({
                title: $translate.instant('accountCreated'),
                text: accountCreatedMsg,
                confirmButton: $translate.instant('ok'),
                press: function () {
                  // para não executar a landing page ao navegar de tela
                  if (!Utils.isInReactNativeWebView() && !$rootScope.isDesktop) {
                    localStorage.setItem('landingPageFlowExecuted', 'true')
                    $rootScope.landingPageFlowExecuted = true
                    showAppMobileNativeModal()
                  }
                  $state.go('home')
                  $scope.signupBtnLoading = false
                }
              })
            })
          }
        },
        function (error) {
          if (error) {
            if (
              error.data &&
              error.data.indexOf('USER_ALREADY_REGISTERED') !== -1
            ) {
              $scope.wrongMessage.email = $translate.instant('userEmailAlreadyCreatedMsg')
            } else if (
              error.data &&
              error.data.indexOf('COMPANY_NOT_FOUND') !== -1
            ) {
              $scope.wrongMessage.company = $translate.instant('companyNotFound')
            } else {
              ToastService.defaultErrorToast()
            }
          }
          $scope.signupBtnLoading = false
        }
      )
    }
  }

  $scope.onConfirmPasswordChange = function (evt) {
    $scope.userSignUp.repeatPassword = evt.detail.value
  }

  $scope.onPasswordChange = function (evt) {
    $scope.userSignUp.password = evt.detail.value
    if ($scope.strongPasswordEnabled) {
      $scope.passwordStrength = StrongPasswordService.verifyPasswordStrength($scope.userSignUp.password, $scope.passwordRules)
    }
  }

  $scope.onEmailChange = function (evt) {
    $scope.userSignUp.email = evt.detail.value
  }

  $scope.onCompanyChange = function (evt) {
    $scope.userSignUp.company = evt.detail.value
  }

  $scope.goToLoginScreen = function () {
    $state.go('login')
  }

  $scope.openIntercomChat = function () {
    IntercomService.show()
  }

  $scope.showPasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.auth-container-signup .strong-password-tooltip').removeClass('hidden-tooltip')
    }
  }

  $scope.hidePasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.auth-container-signup .strong-password-tooltip').addClass('hidden-tooltip')
    }
  }

  $scope.isButtonDisabled = function () {
    const inputsEmpty = !$scope.userSignUp.password || !$scope.userSignUp.repeatPassword
    let passwordRulesNotChecked = false
    if ($scope.strongPasswordEnabled) {
      passwordRulesNotChecked = $scope.passwordStrength !== 'FIVE'
    }

    return inputsEmpty || passwordRulesNotChecked
  }

  function _verifyTokenInUrlParams (stateParams) {
    if (stateParams.inviteToken) {
      AuthService.getInviteTokenExists(stateParams.inviteToken)
        .then(api._hasTokenLoadDataUser)
        .catch(api._showErrorNotHasToken)
    } else {
      api._loadOldInvitation(stateParams)
    }
  }

  function _setInviteTokenWhenSignUp (inviteToken) {
    $scope.userSignUp.inviteTokenUser = inviteToken
  }

  function _hasTokenLoadDataUser (response) {
    if (response) {
      const { name, email, company } = response

      $scope.isCompanyFieldDisabled = company
      $scope.isEmailDisabled = email

      $scope.userSignUp = {
        email,
        name,
        company
      }

      $scope.flags.loadingDataUser = false
    }
  }

  function _showErrorNotHasToken (error) {
    if (error.data.code === 'NOT_FOUND') {
      $scope.flags.loadingDataUser = false
      $scope.tokenHasBeenUsed = true
    }
  }

  function _loadDataUserPerParameters (stateParams) {
    $scope.isCompanyFieldDisabled = stateParams.company
    $scope.isEmailDisabled = stateParams.email

    $scope.userSignUp = {
      email: stateParams.email,
      name: stateParams.name,
      company: stateParams.company
    }

    $scope.flags.loadingDataUser = false
  }

  function _loadOldInvitation (stateParams) {
    if (!stateParams.company || !stateParams.name || !stateParams.email) {
      $scope.flags.loadingDataUser = false
      $scope.tokenHasBeenUsed = true

      return
    }

    AuthService.checkIfUserExists(stateParams.email, stateParams.company)
      .then(() => api._loadDataUserPerParameters(stateParams))
      .catch(api._showErrorNotHasToken)
  }
}

export { SignupController }
